import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { convertImageUrl_L_to_M } from '~/backend/helper';

import { api_getBannersByBannerGroupName } from '~/backend/api_calls';

import { PuzzleBannerLoader } from '~/components/common/SkeletonLoaders';
import arrowrighticon from '~/images/arrow-black.svg';

const PuzzleBanner = () => {
	const groupName = 'PuzzleBanner';
	const { t } = useTranslation();
	const [banners, setBanners] = useState([]);

	useEffect(() => {
		api_getBannersByBannerGroupName(groupName)
			.then(json => {
				setBanners(json.items);
			})
			.catch(error => {
				console.log(error);
			});
	}, []);

	return (
		<div className="content-wrapper content-wrapper-home">
			{banners.length == 0 ? (
				<PuzzleBannerLoader />
			) : (
				<div className="puzzlebanners">
					{banners.map((banner, index) =>
						banner.nu ? (
							<Link key={index} to={banner.nu}>
								<div className="banner">
									<img
										className="banner-img"
										src={convertImageUrl_L_to_M(banner.img1) ?? banner.img2}
										alt="banner"
										loading="lazy"
										width="572px"
										height="227px"
									/>

									<div className="info-overlay">
										<div className="info-container">
											<h3>{banner.tl}</h3>
											<div className="browse-icon">
												<img src={arrowrighticon} alt="Browse category icon " loading="lazy" />
											</div>
										</div>
									</div>
								</div>
							</Link>
						) : (
							<div key={index} className="banner">
								<img
									className="banner-img"
									src={convertImageUrl_L_to_M(banner.img1) ?? banner.img2}
									alt="banner"
									loading="lazy"
									width="572px"
									height="227px"
								/>

								<div className="info-overlay">
									<div className="info-container">
										<h3>{banner.tl}</h3>
										<div className="browse-icon">
											<img src={arrowrighticon} alt="Browse category icon " loading="lazy" />
										</div>
									</div>
								</div>
							</div>
						)
					)}
				</div>
			)}
		</div>
	);
};

export default PuzzleBanner;
